// src/components/common/Badge.jsx
import React from 'react';

const Badge = ({
    children,
    variant = 'gray',
    size = 'md',
    className = '',
    dot = false,
    ...props
}) => {
    const baseStyles = 'inline-flex items-center gap-1.5 font-medium rounded-full';

    const variants = {
        success: 'bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border border-green-200',
        warning: 'bg-gradient-to-r from-yellow-100 to-orange-100 text-yellow-800 border border-yellow-200',
        danger: 'bg-gradient-to-r from-red-100 to-pink-100 text-red-800 border border-red-200',
        info: 'bg-gradient-to-r from-blue-100 to-cyan-100 text-blue-800 border border-blue-200',
        primary: 'bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-800 border border-purple-200',
        gray: 'bg-gradient-to-r from-gray-100 to-slate-100 text-gray-800 border border-gray-200',
        dark: 'bg-gray-800 text-white',
    };

    const sizes = {
        xs: 'px-2 py-0.5 text-xs',
        sm: 'px-2.5 py-0.5 text-xs',
        md: 'px-3 py-1 text-sm',
        lg: 'px-3.5 py-1.5 text-sm',
    };

    const dotColors = {
        success: 'bg-success-500',
        warning: 'bg-warning-500',
        danger: 'bg-danger-500',
        info: 'bg-accent-500',
        primary: 'bg-primary-500',
        gray: 'bg-gray-500',
        dark: 'bg-gray-700',
    };

    const variantClass = variants[variant] || variants.gray;
    const sizeClass = sizes[size] || sizes.md;

    return (
        <span
            className={`${baseStyles} ${variantClass} ${sizeClass} ${className}`}
            {...props}
        >
            {dot && <span className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]}`}></span>}
            {children}
        </span>
    );
};

export default Badge;
